<script setup>
import { computed } from 'vue'
import { useScrollReveal } from '@/composables/useScrollReveal'

const props = defineProps({
  /** Element to render as — keeps semantics (article, figure, li…) intact. */
  as: {
    type: String,
    default: 'div'
  },
  /** Stagger in milliseconds, applied as a CSS transition-delay. */
  delay: {
    type: Number,
    default: 0,
    validator: (value) => value >= 0 && value <= 2000
  }
})

const { el, revealed } = useScrollReveal()

const style = computed(() => ({ '--reveal-delay': `${props.delay}ms` }))
</script>

<template>
  <component :is="as" ref="el" class="reveal" :class="{ 'is-revealed': revealed }" :style="style">
    <slot />
  </component>
</template>
